const compareTime = (left, right) => {
  if (!left && !right) return 0;
  if (!left) return 1;
  if (!right) return -1;
  return String(left).localeCompare(String(right));
};

const pickEarlier = (left, right) => {
  if (!left) return right;
  if (!right) return left;
  return compareTime(left, right) <= 0 ? left : right;
};

const pickLater = (left, right) => {
  if (!left) return right;
  if (!right) return left;
  return compareTime(left, right) >= 0 ? left : right;
};

export const groupAppointmentServicesByProfessional = (services, getName) => {
  const groups = new Map();
  const order = [];

  const sorted = [...(services || [])].sort((left, right) =>
    compareTime(left?.period?.from, right?.period?.from),
  );

  sorted.forEach((service) => {
    const teamMemberId = String(service?.teamMemberId || '').toLowerCase();
    const existing = groups.get(teamMemberId);
    const name = getName(service);

    if (existing) {
      existing.names.push(name);
      existing.period = {
        from: pickEarlier(existing.period.from, service?.period?.from),
        to: pickLater(existing.period.to, service?.period?.to),
      };
      return;
    }

    groups.set(teamMemberId, {
      teamMemberId,
      names: [name],
      period: { from: service?.period?.from, to: service?.period?.to },
    });
    order.push(teamMemberId);
  });

  return order.map((id) => groups.get(id));
};
